// The react_rails gem will load any client-side react components here.

// Component names must be relative to this directory:
const componentRequireContext = require.context("js/components", true);

document.addEventListener("turbolinks:load", function() {
  ReactRailsUJS.useContext(componentRequireContext);
});
